import { t } from 'i18next';
import React from 'react'
import { Card, Col, Row } from "react-bootstrap"
import { __FormulaId, __KPIAgregations, __KPIPeriods, __MasterKPIStatusId } from '../../../../common/Dictionaries';
import CLabel from '../../../../components/Common/CLabel';
import '../../../../styles/css/sKPI/Maintainers/MasterKpiCardSelection.css'

function MasterKpiInfo(props) {
    //Parametros de entrada.
    const inputParam_ObjMasterKpi = props.objMasterKpi === undefined || props.objMasterKpi === null ? null : props.objMasterKpi;
    const inputParam_SetterSelectedMasterKpi = props.setterMasterKpi === undefined || props.setterMasterKpi === null ? null : props.setterMasterKpi;
    const inputParam_MasterKpiSelected = props.masterKpiSelected === undefined || props.masterKpiSelected === null ? null : props.masterKpiSelected;
    const inputParam_ShowBoxBorder = props.showBoxBorder === undefined || props.showBoxBorder === null ? true : props.showBoxBorder;
    const inputParam_ListMeasurmentUnits = props.listMeasurmentUnits !== null && props.listMeasurmentUnits !== undefined ? props.listMeasurmentUnits : null;
    const inputParam_ListObjetives = props.listObjetives !== null && props.listObjetives !== undefined ? props.listObjetives : null;
    const SelectedMasterKpi = () => {
        inputParam_SetterSelectedMasterKpi && inputParam_SetterSelectedMasterKpi(inputParam_ObjMasterKpi)
    };

    return (
        <Card className={`mb-2 ${inputParam_ShowBoxBorder ? '' : 'border-0'}`} onClick={ SelectedMasterKpi }>
            <Card.Body className={`card-masterkpi p-0 ${inputParam_MasterKpiSelected ? (inputParam_MasterKpiSelected.id === inputParam_ObjMasterKpi.id ? "card-masterkpi-checked" : "") : ""}`}>
                {
                    !inputParam_ShowBoxBorder &&
                    <>
                        <Row>
                            <Col>
                                <CLabel
                                    labelText={ t('data-lang-lbl-code') }
                                    labelValue={ inputParam_ObjMasterKpi !== null ? inputParam_ObjMasterKpi.masterKpiCode !== undefined ? inputParam_ObjMasterKpi.masterKpiCode : "" : "" }
                                />
                            </Col>
                            <Col className='col-auto'>
                                <CLabel
                                    labelText={ t('data-lang-lbl-status') }
                                    labelValue={ inputParam_ObjMasterKpi !== null ? inputParam_ObjMasterKpi.statusId !== undefined ? t(__MasterKPIStatusId.find(x => x.key === inputParam_ObjMasterKpi.statusId).text) : "" : "" }
                                />
                            </Col>
                        </Row>
                        <Row className='pt-3'>
                            <Col>
                                <CLabel
                                    labelText={ t('data-lang-lbl-name') }
                                    labelValue={ inputParam_ObjMasterKpi !== null ? inputParam_ObjMasterKpi.name !== undefined ? inputParam_ObjMasterKpi.name : "" : "" }
                                />
                            </Col>
                        </Row>
                        <Row className='pb-3'>
                            <Col>
                                <CLabel
                                    labelText={ t('data-lang-lbl-description') }
                                    labelValue={ inputParam_ObjMasterKpi !== null ? inputParam_ObjMasterKpi.descripcion !== undefined ? inputParam_ObjMasterKpi.descripcion : "" : "" }
                                />
                            </Col>
                        </Row>
                    </>
                }
                {
                    inputParam_ShowBoxBorder &&
                    <>
                        <div className="card-masterkpi-title">
                            <h5>
                                <p>
                                    { t(inputParam_ObjMasterKpi.name) }
                                </p>
                            </h5>
                        </div>
                        <Row className='px-2'>
                            <Col>
                                <CLabel
                                    labelText={ t('data-lang-lbl-code') }
                                    labelValue={ inputParam_ObjMasterKpi !== null ? inputParam_ObjMasterKpi.masterKpiCode !== undefined ? inputParam_ObjMasterKpi.masterKpiCode : "" : "" }
                                />
                            </Col>
                            <Col>
                                <CLabel
                                    labelText={ t('data-lang-lbl-status') }
                                    labelValue={ inputParam_ObjMasterKpi !== null ? inputParam_ObjMasterKpi.statusId !== undefined ? t(__MasterKPIStatusId.find(x => x.key === inputParam_ObjMasterKpi.statusId).text) : "" : "" }
                                />
                            </Col>
                        </Row>
                        <Row className='px-2'>
                            <Col>
                                <CLabel
                                    labelText={ t('data-lang-lbl-description') }
                                    labelValue={ inputParam_ObjMasterKpi !== null ? inputParam_ObjMasterKpi.descripcion !== undefined ? inputParam_ObjMasterKpi.descripcion : "" : "" }
                                />
                            </Col>
                        </Row>
                    </>
                }
                <div className='border rounded-1'>
                <div className='p-2'>
                    <Row>
                        <Col>
                            <CLabel
                                labelText={ t('data-lang-lbl-measurementunit') }
                                labelValue={ inputParam_ObjMasterKpi !== null && inputParam_ListMeasurmentUnits !== null ? inputParam_ObjMasterKpi.measurementUnitId !== undefined ? inputParam_ListMeasurmentUnits.find(x => x.key === inputParam_ObjMasterKpi.measurementUnitId).text : "" : "" }
                            />
                        </Col>
                        <Col>
                            <CLabel
                                labelText={ t('data-lang-lbl-measurementperiod') }
                                labelValue={ inputParam_ObjMasterKpi !== null ? inputParam_ObjMasterKpi.measurementPeriodId !== undefined ? t(__KPIPeriods.find(x => x.key === inputParam_ObjMasterKpi.measurementPeriodId).text) : "" : "" }
                            />
                        </Col>
                    </Row>
                    <Row>                  
                        <Col>
                            <CLabel
                                labelText={ t('data-lang-lbl-timeaggregation') }
                                labelValue={ inputParam_ObjMasterKpi !== null ? inputParam_ObjMasterKpi.timeAggregationId !== undefined ? t(__KPIAgregations.find(x => x.key === inputParam_ObjMasterKpi.timeAggregationId).text) : "" : "" }
                            />
                        </Col>
                        <Col>
                            <CLabel
                                labelText={ t('data-lang-lbl-field-formulaid') }
                                labelValue={ inputParam_ObjMasterKpi !== null ? inputParam_ObjMasterKpi.formulaId !== undefined ? t(__FormulaId.find(x => x.key === inputParam_ObjMasterKpi.formulaId).text) : "" : "" }
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <CLabel
                                labelText={ t('data-lang-lbl-objetive') }
                                labelValue={ inputParam_ObjMasterKpi !== null && inputParam_ListObjetives !==null ? inputParam_ObjMasterKpi.objetiveId !== undefined ? inputParam_ListObjetives.find(x => x.key === inputParam_ObjMasterKpi.objetiveId).text : "" : "" }
                            />
                        </Col>
                    </Row>
                </div>
                </div>
            </Card.Body>
        </Card>
    );
}

export default MasterKpiInfo;